import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-x-circle",
  templateUrl: "./med-icon-x-circle.component.html",
})
export class MedIconXCircleComponent extends SvgMixinComponent {}
